module.exports = __webpack_public_path__ + "static/img/img-sreen04.2b7f126.jpg";